module.exports = __webpack_public_path__ + "static/media/shield.238fb530.png";